import { useState } from 'react';
import { useRoarSound } from '../../hooks/useRoarSound';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AgendaSection from './components/AgendaSection';
import ConceptSection from './components/ConceptSection';
import ExperienceSection from './components/ExperienceSection';
import ForWhomSection from './components/ForWhomSection';
import BehindSection from './components/BehindSection';
import NumbersSection from './components/NumbersSection';
import SponsorshipSection from './components/SponsorshipSection';
import CTASection from './components/CTASection';
import SiteFooter from './components/SiteFooter';
import ParticipationModal from './components/ParticipationModal';
import SponsorshipModal from './components/SponsorshipModal';

export default function HomePage() {
  const [participateOpen, setParticipateOpen] = useState(false);
  const [sponsorOpen, setSponsorOpen] = useState(false);

  // Rugido de leoa toca uma única vez ao entrar no site
  useRoarSound(0.55);

  return (
    <div className="font-sans bg-obsidian">
      <Navbar
        onParticipate={() => setParticipateOpen(true)}
      />

      <main>
        <HeroSection
          onParticipate={() => setParticipateOpen(true)}
          onSponsor={() => setSponsorOpen(true)}
        />
        <AgendaSection />
        <ConceptSection />
        <ExperienceSection />
        <ForWhomSection />
        <BehindSection />
        <NumbersSection />
        <SponsorshipSection onSponsor={() => setSponsorOpen(true)} />
        <CTASection
          onParticipate={() => setParticipateOpen(true)}
          onSponsor={() => setSponsorOpen(true)}
        />
      </main>

      <SiteFooter />

      <ParticipationModal
        open={participateOpen}
        onClose={() => setParticipateOpen(false)}
      />
      <SponsorshipModal
        open={sponsorOpen}
        onClose={() => setSponsorOpen(false)}
      />
    </div>
  );
}
